export default __webpack_public_path__ + "static/media/Landing-gmm3.07ca8a6e.png";